<template>
    <div v-loading-fullscreen="vloading">
        <ldc-dialog
            title="Thay đổi email"
            :clickoutside="false"
            :fullscreen="$detect == 'mobile'"
            width="35%"
            class="dialog-email"
            :visible.sync="changeEmail">
                <div class="main-dialog-email">
                    <p class="mb-1 fs-14px">Email hiện tại:</p>
                    <p class="mb-20px fs-14px fw-600">{{ user.email }}</p>
                    <p class="mb-10px fs-14px title">Nhập email mới</p>
                    <input type="text" class="w-100 input-email" v-model="newEmail"/>
                    <div class="text-danger fs-12px ml-1">
                        {{ messageEmail }}
                        <p class="mb-0" v-if="numberCountdown > 0">Mã xác nhận có hiệu lực {{ numberCountdown }}s.</p>
                        <p class="mb-0 text-primary mt-1" role="button" @click="sendCode()" v-if="numberCountdown === 0"><ins>Gửi lại mã xác nhận.</ins></p>
                    </div>
                    <div class="text-danger ml-1 fs-12px">
                        {{ validateEmail }}
                    </div>
                    <div v-if="statusEmail">
                        <p class="mb-10px fs-14px title mt-20px">Mã xác nhận</p>
                        <input type="text" class="w-100 input-email" v-model="codeEmail"/>
                        <div class="text-danger fs-12px ml-1">
                            {{ validateCode }}
                        </div>
                    </div>
                </div>
                <div class="pt-10px pb-20px px-20px footer-modal">
                    <button class="btn btn-outline-primary py-2 px-4 mr-2" @click="cancelEmail()">Huỷ</button>
                    <button class="btn btn-primary py-2 px-4 ml-2" @click="confirmEmail()">Xác nhận</button>
                </div>
        </ldc-dialog>
    </div>
</template>

<script>
import { updateToken } from '@/config/token';
export default {
    props: ['active'],
    data() {
        return {
            changeEmail: false,
            statusEmail: false,
            validateEmail: '',
            validateCode: '',
            newEmail: '',
            messageEmail: '',
            codeEmail: '',
            vloading: false,
            numberCountdown: null,
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        }
    },
    watch: {
        active(val){
            this.changeEmail= val;
        },
        changeEmail(val) {
            this.$emit('update:active', val);
        },
        numberCountdown(val) {
            this.countDownTimer();
        }
    },
    methods: {
        countDownTimer() {
            if(this.numberCountdown > 0) {
                setTimeout(() => {
                    this.numberCountdown--;
                }, 1000)
            }
        },
        cancelEmail() {
            this.changeEmail = false;
            this.statusEmail = false;
            this.validateEmail = '';
            this.newEmail = '';
            this.messageEmail = '';
            this.validateCode = '';
            this.codeEmail = '';
            this.numberCountdown = null;
        },
        async confirmEmail() {
            if(this.statusEmail == false) {
                this.vloading = true;
                await apiPost('/v2/profile/send_verified_email', {
                    email: this.newEmail,
                }).then(res => {
                    this.statusEmail = true;
                    this.messageEmail = res.message;
                    this.validateEmail = '';
                    this.numberCountdown = res.data.time_expire * 60;
                }).catch(err => {
                    if(err.status == 422) {
                        this.validateEmail = err.data.data.email;
                    }
                })
                this.vloading = false;
            } else {
                this.vloading = true;
                await apiPut('/v2/profile', {
                    email: this.newEmail,
                    verified_email: this.codeEmail,
                }).then(res => {
                    if(res.success == 1) {
                        this.$message({
                            message: 'Cập nhật thông tin thành công',
                            type: 'success',
                            center: true,
                        });
                        this.user.email = res.data.user.email;
                        this.changeEmail = false;
                        this.statusEmail = false;
                        this.validateEmail = '';
                        this.newEmail = '';
                        this.messageEmail = '';
                        this.validateCode = '';
                        this.codeEmail = '';
                        updateToken(res.data.token.access_token, res.data.token.exp_at);
                    } else {
                        this.validateCode = res.message;
                    }
                }).catch(err => {
                    if(err.status == 422) {
                        this.validateCode = err.data.data.verified_email;
                    }
                })
                this.vloading = false;
            }
        },
        sendCode() {
            this.statusEmail = false;
            this.confirmEmail();
        }
    }
}
</script>

<style lang="scss">
.dialog-email {
    .close-dialog {
        display: none !important;
    }
    .ldc-dialog-content {
        padding: 0 !important;
        border-radius: 10px !important;
        .title-dialog {
            padding: 20px 20px 10px!important;
            margin-bottom: 0 !important;
            font-weight: 600;
        }
        .main-dialog {
            .main-dialog-email {
                padding: 10px 20px;
                .title {
                    color: #666;
                }
                .input-email {
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    padding: 8px 10px;
                    border-radius: 8px;
                    &:focus {
                        border: 1px solid #007bff;
                        outline: none !important;
                    }
                }
            }
            .footer-modal {
                button {
                    width: calc(50% - 8px);
                    border-radius: 8px !important;
                }
                .btn-outline-primary {
                    border: 1px solid #007bff !important;
                    &:hover {
                        background: #fff !important;
                        color: #007bff !important;
                    }
                }
            }
        }
    }
}
.profile-mobile {
    .dialog-email {
        .ldc-dialog-content {
            border-radius: 0 !important;
        }
        .close-modal-mobile {
            display: none !important;
        }
        .title-dialog {
            padding: 10px !important;
            background: #007bff !important;
            color: #fff !important;
            font-size: 16px !important;
            font-weight: 400 !important;
            text-align: center !important;
        }
        .main-dialog-email {
            padding: 10px 15px !important;
        }
        .footer-modal {
            padding: 10px 15px !important;
        }
    }
}
.ldc-loading-fullscreen {
    z-index: 99999999999;
}
</style>
